import React from 'react';
import { BlockProps } from './interfaces';

export default function Block(props: BlockProps) {
  const { id, children, className, style, dataProps } = props;
  return (
    <div id={id} className={className} style={style} {...dataProps}>
      {children}
    </div>
  );
}
